import React, { useState } from 'react';
import { Collapse, Input, Card, CardBody } from 'reactstrap';
import AppButton from './AppButton';
import styles from './ReceiverInstructions.module.scss';

export default function ReceiverInstructions(props) {

    const [instructions, setInstructions] = useState("");

    return (
        <Collapse className={styles.receiverInstructions} isOpen={props.isOpen}>
            <Card>
                <div className={styles.cardCloseX} onClick={e => props.onClose()}>&times;</div>
                <CardBody>
                    <Input
                        className={styles.input}
                        placeholder="Enter instructions."
                        type="textarea"
                        value={instructions}
                        onChange={e => setInstructions(e.target.value)}
                        />
                    <AppButton
                        iconName="icon-button-tick"
                        highlight={true}
                        actionText="Confirm"
                        footer="Tap to confirm"
                        ajaxInProgress={props.ajaxInProgress}
                        onClick={ e => props.saveInstructions(instructions) }
                    />
                </CardBody>
            </Card>
        </Collapse>
    );
};